"use client";
import { Modal, Button, FormProps } from "@basic-components";
import { ReactNode, } from "react";
import * as yup from "yup";
import { useFormContext } from "react-hook-form";
import { FormProps as FormPropsType } from '@general-components/Form/types';
import { Form } from '@general-components'

const ActionButtonSubmit = ({
  onClick,
}: {
  onClick: (values: any) => void;
}) => {
  const { handleSubmit, formState: { isSubmitting, errors } } = useFormContext();
  const handleOk = async (values: any) => {
    await onClick(values);
   // console.log("ok:",values);
  }
  return (
    <Button onClick={handleSubmit(handleOk)} type="primary" loading={isSubmitting} disabled={isSubmitting}>
      确定
    </Button>
  );
};

export const ModalForm = ({
  visible,
  onCancel,
  onOk,
  schema,
  children,
  title,
  defaultValues,
  form,
  isView = false,
  width,
  footer = true,
  ...formProps
}: {
  visible: boolean;
  onCancel: () => void;
  onOk: (values: any) => void;
  schema?: yup.ObjectSchema<any>;
  children: ReactNode;
  title: string;
  defaultValues?: any;
  form?: Pick<FormPropsType, "form">;
  isView?: boolean;
  width?: number;
  footer?: ReactNode | null,
  onChange?: (values: any) => void;
} & Pick<FormProps, "labelCol" | "wrapperCol">) => {
  return (
    <Modal destroyOnHidden width={width} open={visible} onCancel={onCancel} title={title} footer={null}>
      <Form schema={schema} defaultValues={defaultValues} form={form as any} isView={isView} {...formProps}>
        {children}
        {
          !isView && footer && (
            <div className="flex justify-end gap-3">
              <Button onClick={onCancel}>取消</Button>
              <ActionButtonSubmit onClick={onOk}  />
            </div>
          )
        }        
      </Form>
    </Modal>
  );
};
